import CheckoutAgreements from './CheckoutAgreements';

export default CheckoutAgreements;
